class StringUtils
{
    static stripHtml = (str: string): string => {
        return str.replace(/<[^>]*>/g, '');
    }

    static isHtmlEmpty = (str: string): boolean => {
        return (StringUtils.stripHtml(str).trim().length === 0);
    }

    static toClassName = (str: string): string => {
        return str
            .replace(/([a-z])([A-Z])/g, '$1-$2')
            .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
            .toLowerCase();
    }

}

export default StringUtils;
